
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 4.5V6c0 .553.447 1 1 1h2V4.5a1.5 1.5 0 00-3 0zM4.5 3c.313.419.5.938.5 1.5V14c0 1.103.897 2 2 2s2-.897 2-2v-.166C9 12.822 9.822 12 10.834 12H16V6a3 3 0 00-3-3H4.5zm11 14c1.934 0 3.5-1.566 3.5-3.5 0-.275-.225-.5-.5-.5h-7.666a.834.834 0 00-.834.834V14a3 3 0 01-3 3h8.5z","fill":"#999"}})])
          )
        }
      }
    